<section #timelineSection class="py-8 sm:py-14 relative">
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <div class="">
            <div class="max-w-2xl mx-auto text-center"><span
                    class="inline-block text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 mb-3">Your Journey
                    to Success</span>
                <h2 class="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
                    From fresher to <span class="brand-gradient-text">dream job</span></h2>
                <p class="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">Simple steps to help you prepare,
                    practice and land your dream job.</p>
            </div>
        </div>
        <div class="mt-16">
            <div class="hidden lg:block relative">
                <div class="absolute top-7 left-[6.25%] right-[6.25%] h-1 bg-slate-100 rounded-full">
                    <div class="absolute top-0 left-0 h-1 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 transition-all duration-150 ease-out z-0"
                        [style.width.%]="scrollProgress"></div>
                </div>
                <div class="relative grid grid-cols-8 gap-2">
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-1">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-user-plus w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">1</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Create Profile</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Build your professional profile and set
                            your career preferences.
                        </p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-2">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-upload w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">2</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Create ATS-Optimized Resume</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Generate an ATS-friendly resume in
                            minutes.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-3">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-clipboard-list w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <rect height="4" rx="1" ry="1" width="8" x="8" y="2"></rect>
                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">
                                </path>
                                <path d="M12 11h4"></path>
                                <path d="M12 16h4"></path>
                                <path d="M8 11h.01"></path>
                                <path d="M8 16h.01"></path>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">3</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Practice Mock Tests</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Improve your skills with adaptive
                            company specific mock tests.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-4">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-mic w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 19v3"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <rect height="13" rx="3" width="6" x="9" y="2"></rect>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">4</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Practice Mock Interviews</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">AI-powered video-based mock interviews
                            with instant feedback.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-5">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-map w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z">
                                </path>
                                <path d="M15 5.764v15"></path>
                                <path d="M9 3.236v15"></path>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">5</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Check Your Placement Readiness
                            Score</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Track your placement readiness based on
                            mock tests and interview performance.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-6">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-send w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z">
                                </path>
                                <path d="m21.854 2.147-10.94 10.939"></path>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">6</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Apply for Jobs</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Discover and apply to relevant job
                            opportunities in one click.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-7">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-check-circle w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">7</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900"> Complete Hiring Process</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Successfully complete proctored
                            assessments and Proctored AI interviews.</p>
                    </div>
                    <div class="flex flex-col items-center text-center" data-testid="timeline-step-8">
                        <div
                            class="grid place-items-center w-14 h-14 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-party-popper w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.8 11.3 2 22l10.7-3.79"></path>
                                <path d="M4 3h.01"></path>
                                <path d="M22 8h.01"></path>
                                <path d="M15 2h.01"></path>
                                <path d="M22 20h.01"></path>
                                <path
                                    d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10">
                                </path>
                                <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"></path>
                                <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"></path>
                                <path
                                    d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z">
                                </path>
                            </svg><span
                                class="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">8</span>
                        </div>
                        <h4 class="mt-4 font-display font-bold text-sm text-slate-900">Get Hired</h4>
                        <p class="mt-1 text-xs text-slate-500 leading-snug px-1">Receive your offer and start your dream career.</p>
                    </div>
                </div>
            </div>
            <div class="lg:hidden relative pl-4">
                <div class="absolute top-6 bottom-10 left-10 w-1 bg-slate-100 rounded-full z-0">
                    <div class="absolute top-0 left-0 w-1 rounded-full bg-gradient-to-b from-indigo-500 to-violet-500 transition-all duration-150 ease-out"
                        [style.height.%]="scrollProgress"></div>
                </div>
                <div class="space-y-8">
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-user-plus w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>1</span>. <span>Create Profile</span></h4>
                            <p class="text-sm text-slate-500">Build your professional profile.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-upload w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>2</span>. <span>Build Resume</span>
                            </h4>
                            <p class="text-sm text-slate-500">Create an ATS-friendly resume.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-clipboard-list w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <rect height="4" rx="1" ry="1" width="8" x="8" y="2"></rect>
                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">
                                </path>
                                <path d="M12 11h4"></path>
                                <path d="M12 16h4"></path>
                                <path d="M8 11h.01"></path>
                                <path d="M8 16h.01"></path>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>3</span>. <span>Practice Mock Tests</span></h4>
                            <p class="text-sm text-slate-500">Improve your skills with mock tests.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-mic w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 19v3"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <rect height="13" rx="3" width="6" x="9" y="2"></rect>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>4</span>. <span>Practice Mock Interviews</span>
                            </h4>
                            <p class="text-sm text-slate-500">Practice AI-powered mock interviews.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-map w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z">
                                </path>
                                <path d="M15 5.764v15"></path>
                                <path d="M9 3.236v15"></path>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>5</span>. <span>Check Readiness Score</span></h4>
                            <p class="text-sm text-slate-500">Track your placement readiness.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-send w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z">
                                </path>
                                <path d="m21.854 2.147-10.94 10.939"></path>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>6</span>. <span>Apply for Jobs</span>
                            </h4>
                            <p class="text-sm text-slate-500">Discover and apply for relevant jobs.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-check-circle w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>7</span>. <span>Complete Hiring Process</span>
                            </h4>
                            <p class="text-sm text-slate-500">Complete assessments and AI interviews.</p>
                        </div>
                    </div>
                    <div class="relative flex items-start gap-5">
                        <div
                            class="grid place-items-center w-12 h-12 rounded-2xl bg-white border-2 border-indigo-100 text-indigo-600 premium-shadow shrink-0 relative z-10">
                            <svg aria-hidden="true" class="lucide lucide-party-popper w-5 h-5" fill="none" height="24"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.8 11.3 2 22l10.7-3.79"></path>
                                <path d="M4 3h.01"></path>
                                <path d="M22 8h.01"></path>
                                <path d="M15 2h.01"></path>
                                <path d="M22 20h.01"></path>
                                <path
                                    d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10">
                                </path>
                                <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"></path>
                                <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"></path>
                                <path
                                    d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z">
                                </path>
                            </svg>
                        </div>
                        <div class="pt-1">
                            <h4 class="font-display font-bold text-slate-900"><span>8</span>. <span>Get Hired</span>
                            </h4>
                            <p class="text-sm text-slate-500">Get your offer and start your career.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>